export default "__VITE_ASSET__fabb9fbe__"